if (!customElements.get("cart-upsell")) {
  customElements.define(
    "cart-upsell",
    class CartUpsell extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector("[data-cart-upsell-content]");
        this.sources = this.getSources();
        this.loadRecommendation();
      }

      getSources() {
        const sourceData = this.querySelector("[data-cart-upsell-sources]");
        if (!sourceData) return [];

        try {
          return JSON.parse(sourceData.textContent).filter(
            (source) => source.productId && source.lineKey && source.quantity === 1
          );
        } catch (error) {
          return [];
        }
      }

      async loadRecommendation() {
        for (const source of this.sources) {
          const recommendation = await this.getRecommendation(source.productId);
          if (!recommendation) continue;

          this.activeSource = source;
          this.content.innerHTML = recommendation;
          this.hidden = false;
          this.bindControls();
          return;
        }
      }

      async getRecommendation(productId) {
        const root = window.Shopify?.routes?.root || "/";
        const params = new URLSearchParams({
          section_id: this.dataset.sectionId,
          product_id: productId,
          limit: "1",
          intent: "complementary",
        });

        try {
          const response = await fetch(`${root}recommendations/products?${params}`);
          if (!response.ok) return null;

          const html = await response.text();
          const documentFragment = new DOMParser().parseFromString(html, "text/html");
          return documentFragment.querySelector("[data-cart-upsell-card]")?.outerHTML || null;
        } catch (error) {
          return null;
        }
      }

      bindControls() {
        this.variantInput = this.querySelector("[data-cart-upsell-variant]");
        this.button = this.querySelector("[data-cart-upsell-submit]");
        this.error = this.querySelector("[data-cart-upsell-error]");

        if (!this.variantInput || !this.button) return;
        this.selectMatchingVariant();
        this.updatePrice();
        this.variantInput.addEventListener("change", () => this.updatePrice());
        this.button.addEventListener("click", (event) => this.upgrade(event));
      }

      selectMatchingVariant() {
        if (!this.variantInput.selectedOptions || !this.activeSource.optionValues) return;

        const sourceValues = this.activeSource.optionValues.map((value) => String(value).toLowerCase());
        const matchingOption = Array.from(this.variantInput.options).find((option) => {
          try {
            const optionValues = JSON.parse(option.dataset.optionValues || "[]");
            return optionValues.every((value) => sourceValues.includes(String(value).toLowerCase()));
          } catch (error) {
            return false;
          }
        });

        if (matchingOption && !matchingOption.disabled) {
          this.variantInput.value = matchingOption.value;
        }
      }

      updatePrice() {
        const selectedOption = this.variantInput.selectedOptions?.[0];
        if (!selectedOption) return;

        const price = this.querySelector("[data-cart-upsell-price]");
        const comparePrice = this.querySelector("[data-cart-upsell-compare-price]");
        if (price) price.textContent = selectedOption.dataset.price;
        if (comparePrice) {
          comparePrice.textContent = selectedOption.dataset.comparePrice || "";
          comparePrice.hidden = !selectedOption.dataset.comparePrice;
        }
      }

      async upgrade(event) {
        if (!this.activeSource || this.button.disabled) return;

        const cartDrawer = document.querySelector("cart-drawer");
        if (!cartDrawer) return;

        this.setLoading(true);
        this.showError("");

        const sections = cartDrawer.getSectionsToRender().map((section) => section.id);
        const requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          credentials: "same-origin",
        };

        try {
          const addResponse = await fetch(window.routes.cart_add_url, {
            ...requestOptions,
            body: JSON.stringify({
              items: [{ id: Number(this.variantInput.value), quantity: 1 }],
            }),
          });
          const addState = await addResponse.json();
          if (!addResponse.ok || addState.status) {
            throw new Error(addState.description || "The bundle could not be added.");
          }

          const changeResponse = await fetch(window.routes.cart_change_url, {
            ...requestOptions,
            body: JSON.stringify({
              id: this.activeSource.lineKey,
              quantity: 0,
              sections,
              sections_url: window.location.pathname,
            }),
          });
          const changeState = await changeResponse.json();
          if (!changeResponse.ok || changeState.status) {
            throw new Error(changeState.description || "The original item could not be replaced.");
          }

          cartDrawer.renderContents(changeState, event);
        } catch (error) {
          this.showError(error.message || "Something went wrong. Please try again.");
          this.setLoading(false);
        }
      }

      setLoading(isLoading) {
        this.button.disabled = isLoading;
        this.button.classList.toggle("is-loading", isLoading);
      }

      showError(message) {
        if (!this.error) return;
        this.error.textContent = message;
        this.error.hidden = !message;
      }
    }
  );
}
